import React from 'react'
import { FormattedMessage } from 'react-intl'

const SearchResultsLabel = ({
  totalRecords,
  totalResults,
  className,
  isLoading,
}) => {
  const totalRecordsStr = totalRecords.toLocaleString().replace(/\D\d\d$/, '')
  const totalResultsStr = totalResults.toLocaleString().replace(/\D\d\d$/, '')

  return (
    <div className={className}>
      <h3>
        {isLoading && (
          <FormattedMessage id="search.SearchResults.ResultsHeader.Loading" />
        )}
        {!isLoading && (
          <React.Fragment>
            {
              totalRecords === 1 &&
              <FormattedMessage
                id="search.SearchResults.ResultsHeader.SinglePage"
                values={{
                  totalRecords,
                }}
              />
            }

            {totalRecords !== 0 && totalResults !== 0 && (
              <FormattedMessage
                id="search.SearchResults.ResultsHeader.Pages"
                values={{
                  pageTotal: totalResultsStr,
                  totalRecords
                }}
              />
            )}
          </React.Fragment>
        )}
      </h3>
    </div>
  )
}
export default SearchResultsLabel



// WEBPACK FOOTER //
// ./src/legacy/components/Search/SearchResultsLabel.jsx